const storagePaymentName = 'microaccountPayment';


export const setStoragePaymentData = (uuid, token) => {
    if (!uuid || !token) return false;

    const data = {
        uuid,
        token
    };

    localStorage.setItem(storagePaymentName, JSON.stringify(data));
};

export const getStoragePaymentData = () => {
    const data = localStorage.getItem(storagePaymentName);
    return data ? JSON.parse(data) : false;
}

export const removeStoragePaymentData = () =>
    localStorage.removeItem(storagePaymentName);